import { render, staticRenderFns } from "./secondary.vue?vue&type=template&id=938dbffa&scoped=true"
import script from "./secondary.vue?vue&type=script&lang=ts"
export * from "./secondary.vue?vue&type=script&lang=ts"
import style0 from "./secondary.vue?vue&type=style&index=0&id=938dbffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938dbffa",
  null
  
)

export default component.exports